import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Store } from 'lucide-react';

const PLANS = [
  { id: 'gratuito', label: 'Gratuito', price: 'Gratis', limit: '10 cupons/mes' },
  { id: 'premium', label: 'Premium', price: 'R$ 150/mês', limit: '30 cupons/mês' },
  { id: 'platinum', label: 'Platinum', price: 'R$ 300/mês', limit: '50 cupons/mês' },
  { id: 'black', label: 'Black', price: 'R$ 750/mês', limit: '80 cupons/mês' },
];

export function UserBecomeMerchant({ showDialog, setShowDialog, navigate }) {
  return (
    <>
      <Card className="mt-12 bg-gradient-to-r from-green-600 to-emerald-600 border-0 shadow-lg cursor-pointer hover:shadow-xl transition-shadow"
        onClick={() => setShowDialog(true)} data-testid="become-merchant-card">
        <CardContent className="py-8 px-8 flex flex-col md:flex-row items-center gap-6">
          <div className="bg-white/20 p-4 rounded-xl shrink-0"><Store className="h-12 w-12 text-white" /></div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl font-black text-white mb-2">Quero me tornar um Lojista</h2>
            <p className="text-white/80">Crie cupons, alcance mais clientes e fature mais com o ClubdoCupom</p>
          </div>
          <Button className="bg-white text-green-700 hover:bg-white/90 font-bold px-8 py-3 text-lg rounded-lg shadow-md shrink-0"
            data-testid="become-merchant-card-btn">
            Assinar Agora
          </Button>
        </CardContent>
      </Card>

      <Dialog open={showDialog} onOpenChange={setShowDialog}>
        <DialogContent className="!bg-white max-w-lg">
          <DialogHeader><DialogTitle className="text-xl font-bold text-slate-900">Escolha seu Plano de Lojista</DialogTitle></DialogHeader>
          <div className="space-y-3 mt-2">
            {PLANS.map(p => (
              <div key={p.id} className="flex items-center justify-between p-4 border border-slate-200 rounded-lg hover:bg-slate-50">
                <div>
                  <h3 className="font-bold text-slate-900">{p.label}</h3>
                  <p className="text-lg font-black text-slate-900">{p.price}</p>
                  <p className="text-xs text-slate-500">{p.limit}</p>
                </div>
                <Button size="sm" onClick={() => { setShowDialog(false); navigate('/setup'); }}
                  className="bg-green-600 hover:bg-green-700 text-white" data-testid={`merchant-plan-${p.id}`}>
                  {p.id === 'gratuito' ? 'Comecar Gratis' : 'Assinar'}
                </Button>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
